// src/components/icons/orlo/SmartSlice.tsx

import React from 'react';

interface SmartSliceProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
}

/**
 * 智慧分割圖示
 * Orlo 系統專屬圖示，用於表示智能分割功能
 */
const SmartSlice: React.FC<SmartSliceProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`lucide lucide-orlo-smart-slice ${className}`}
      {...props}
    >
      {/* 主要的魔杖/切片路徑 */}
      <path d="M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14" />
      
      {/* 魔杖裝飾 */}
      <path d="M5 6v4" />
      <path d="M19 14v4" />
      
      {/* 星星效果 */}
      <path d="M10 2v2" />
      <path d="M7 8H3" />
      <path d="M21 16h-4" />
      <path d="M11 3H9" />
    </svg>
  );
};

export default SmartSlice;